(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/retail-game-view/assets/javascripts/retail-game-view.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/retail-game-view/assets/javascripts/retail-game-view.js');
"use strict";


const Loader = svs.components.ReactLoader.Loader;
const selectors = svs.components.marketplaceData.selectors;
const fetchActivatedDrawAction = svs.components.marketplaceData.games.actions.fetchActivatedDrawAction;
const fetchSingleDrawAction = svs.components.marketplaceData.draws.actions.fetchSingleDrawAction;
const fetchBetProposal = svs.components.marketplaceData.betProposal.actions.fetchBetProposal;
const showDialog = svs.components.marketplaceData.dialogWrapper.actions.showDialog;
const _svs$components$lbUti = svs.components.lbUtils,
  DocumentTitle = _svs$components$lbUti.DocumentTitle,
  getGameMyBetsUrl = _svs$components$lbUti.getGameMyBetsUrl;
const ViewHeader = svs.components.marketplace.viewHeader.ViewHeader;
const GameTypeTag = svs.components.marketplace.gameTypeTag.GameTypeTag;
const BoughtFractionsText = svs.components.lbUi.BoughtFractionsText;
const FractionPayment = svs.components.marketplace.fractionPayment.FractionPayment;
const Button = svs.ui.Button;
const _svs$components$marke = svs.components.marketplace.betProposal,
  BetProposalContainer = _svs$components$marke.BetProposalContainer,
  excludedProducts = _svs$components$marke.excludedProducts;
const RacingEventInfo = svs.marketplace.components.retailGameView.RacingEventInfo;
const EventListContainer = svs.components.marketplace.eventList.EventListContainer;
const gameReceipt = svs.components.marketplaceShared.gameReceipt;
const getRetailUrl = svs.components.marketplace.helpers.getRetailUrl;
const getSubProductDisplayName = svs.components.sport.tipsenShared.getSubProductDisplayName;
const _svs$utils$products = svs.utils.products,
  getDisplayName = _svs$utils$products.getDisplayName,
  productIds = _svs$utils$products.productIds;
const getRacingDisplayName = svs.utils.racing.getRacingDisplayName;
const _svs$components$lbUti2 = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti2.useMediaQuery,
  breakpoints = _svs$components$lbUti2.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti2.BREAKPOINT_AM;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useRouteMatch = _ReactRouterDOM.useRouteMatch,
  useLocation = _ReactRouterDOM.useLocation;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const REDIRECT_TO_MY_GAMES_DELAY = 200;
const hasMultipleSharesToggleOn = svs.core.detect.feature('ft-marketplace-multiple-shares');
const RetailGameView = _ref => {
  var _history$state;
  let chatWrapperRef = _ref.chatWrapperRef;
  const hasFetchedBetproposal = useRef(false);
  const hasFetchedDraws = useRef(false);
  useEffect(() => {
    if (chatWrapperRef !== null && chatWrapperRef !== void 0 && chatWrapperRef.current) {
      chatWrapperRef.current.scrollTo(0, 0);
    } else if (document.querySelector('.chat-detail-scroll')) {
      document.querySelector('.chat-detail-scroll').scrollTo(0, 0);
    }
  }, []);
  const hasFractionsPayQuery = useRef(false);
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const groupId = Number(match.params.groupId);
  const activatedDrawId = Number(match.params.activatedDrawId);
  const containerId = Number(match.params.containerId);
  const memberId = useSelector(state => state.customerId);
  const game = useSelector(state => selectors.games.getGame(state, {
    activatedDrawId,
    groupId
  })) || {};
  const loading = game.loading,
    wagerSerial = game.wagerSerial,
    error = game.error,
    drawNumber = game.drawNumber,
    isSubmitted = game.isSubmitted,
    productId = game.productId,
    productName = game.productName,
    containerDescription = game.containerDescription,
    description = game.description,
    subProductId = game.subProductId,
    isFinished = game.isFinished,
    isFavorite = game.isFavorite,
    richDescription = game.richDescription,
    name = game.name,
    maxFractionsPerMember = game.maxFractionsPerMember;
  const hasGameInMemory = useSelector(state => selectors.games.selectHasGameInMemory(state, {
    activatedDrawId,
    groupId
  }));
  const currentPurchasedFractions = useSelector(state => selectors.games.getPurchasedFractionsForMember(state, {
    activatedDrawId,
    memberId: state.customerId,
    groupId
  })) || 0;
  const _useSelector = useSelector(state => {
      var _state$BetProposal$ac;
      return activatedDrawId && state.BetProposal && !((_state$BetProposal$ac = state.BetProposal[activatedDrawId]) !== null && _state$BetProposal$ac !== void 0 && _state$BetProposal$ac.isPrivate) && state.BetProposal[activatedDrawId] || [];
    }),
    betProposal = _useSelector.data;
  const team = useSelector(state => selectors.teams.selectTeam(state, {
    id: groupId
  })) || {};
  const _ref2 = useSelector(state => selectors.draws.getDraw(state, {
      drawNumber,
      productName,
      productId
    })) || {},
    drawName = _ref2.name;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const gameIsLoading = loading || !hasGameInMemory && !error;
  const isCurrentUserAuthenticated = Boolean(memberId);
  useEffect(() => {
    if (!hasFractionsPayQuery.current) {
      if (location.search.includes('fractionData=')) {
        hasFractionsPayQuery.current = true;
      }
    }
  }, [hasFractionsPayQuery]);
  useEffect(() => {
    dispatch(fetchActivatedDrawAction(groupId, activatedDrawId, containerId));
  }, [activatedDrawId, containerId, dispatch, groupId]);
  useEffect(() => {
    if (activatedDrawId && !hasFetchedBetproposal.current) {
      dispatch(fetchBetProposal(activatedDrawId, groupId, productName));
      hasFetchedBetproposal.current = true;
    }
  }, [activatedDrawId, dispatch, groupId, hasFetchedBetproposal, productName]);
  useEffect(() => {
    if (productId && drawNumber && !hasFetchedDraws.current) {
      dispatch(fetchSingleDrawAction(productId, drawNumber));
      hasFetchedDraws.current = true;
    }
  }, [dispatch, drawNumber, productId]);
  const hasSelectedOutcomes = useMemo(() => Object.keys(betProposal || {}).filter(event => Object.keys(betProposal[event]).filter(outcome => Boolean(betProposal[event][outcome])).length > 0).length > 0, [betProposal]);
  if (!gameIsLoading && (error || !hasGameInMemory)) {
    return React.createElement("div", null, React.createElement("h1", null, "N\xE5got gick snett!"));
  }
  if (gameIsLoading) {
    return React.createElement("div", {
      "data-testid": "retail-game-view-loading"
    }, React.createElement(Loader, {
      className: "retail-game-view-spinner",
      inverted: true,
      size: 300
    }));
  }
  const renderBetProposalArea = () => {
    if (!isSubmitted && hasSelectedOutcomes) {
      return React.createElement(BetProposalContainer, {
        activatedDrawId: activatedDrawId,
        groupId: groupId
      });
    }
    if (productId === productIds.RACING) {
      return React.createElement("div", {
        className: "grid-row"
      }, React.createElement(RacingEventInfo, null));
    }
    return React.createElement(EventListContainer, {
      activatedDrawId: activatedDrawId,
      drawNumber: drawNumber,
      groupId: groupId,
      warningMessage: excludedProducts[productName] ? undefined : 'Butiken har valt att inte visa radskiss.'
    });
  };
  const handleNavigateToMyBets = () => {
    dispatch(showDialog({
      title: 'Vidarebefordrar till Mina spel...',
      icon: 'nav-my-games'
    }));
    const startTime = Date.now();
    getGameMyBetsUrl({
      productId,
      wagerSerial,
      drawNumber
    }, (error, targetUrl) => {
      if (error) {
        dispatch(showDialog({
          title: 'Vi kunde tyvärr inte hämta länken till spelet.',
          type: 'error'
        }));
      } else {
        const timePassed = Date.now() - startTime;
        const remainingDelay = Math.max(0, REDIRECT_TO_MY_GAMES_DELAY - timePassed);
        setTimeout(() => window.location.pathname = targetUrl, remainingDelay);
      }
    });
  };
  const handleGoToTeam = () => {
    history.push({
      pathname: getRetailUrl(groupId, team.name),
      search: location.search
    });
  };
  const handleGoBack = () => {
    var _history$location;
    svs.utils.url.refreshQueryString();
    const returnUrl = svs.utils.url.queryString.returnUrl;
    if ((_history$location = history.location) !== null && _history$location !== void 0 && (_history$location = _history$location.state) !== null && _history$location !== void 0 && _history$location.internalLink) {
      history.goBack();
    } else if (returnUrl !== null && returnUrl !== void 0 && returnUrl.includes('https')) {
      window.location.href = returnUrl;
    } else if (returnUrl) {
      history.push(returnUrl);
    } else if (hasFractionsPayQuery) {
      history.push(getRetailUrl(groupId, team.name));
    } else {
      history.goBack();
    }
  };
  const subTitles = [];
  if (productId && drawName) {
    const subProductName = getSubProductDisplayName(subProductId);
    if (subProductName.length === 0) {
      const displayName = productId === productIds.RACING ? getRacingDisplayName(productId) : getDisplayName(productId);
      subTitles.push("".concat(displayName, " ").concat(drawName));
    } else {
      subTitles.push(drawName);
    }
  }
  const payButtonClass = hasMultipleSharesToggleOn ? 'pay-button-multiple-shares-container' : 'pay-button-container';
  let fractionPaymentClasses = 'margin-top-1 padding-bottom-1 ';
  fractionPaymentClasses += payButtonClass;
  const ActivatedDrawButtons = () => {
    if (isSubmitted && currentPurchasedFractions > 0) {
      return React.createElement("div", {
        className: "button-container"
      }, React.createElement(Button, {
        block: isSmall,
        className: "qa-show-my-game",
        inverted: true,
        onClick: handleNavigateToMyBets
      }, "Visa i mina spel"));
    } else if (!isSubmitted && !isSmall) {
      return React.createElement("div", {
        className: ""
      }, React.createElement(FractionPayment, {
        activatedDrawId: activatedDrawId,
        className: fractionPaymentClasses,
        containerId: containerId,
        game: game,
        groupId: groupId,
        memberId: memberId
      }));
    }
    return null;
  };

  const hasCloseButton = !(history !== null && history !== void 0 && (_history$state = history.state) !== null && _history$state !== void 0 && _history$state.hasBackButton) && !hasFractionsPayQuery;
  return React.createElement("div", {
    className: "retail-game-view-container ".concat(isSmall ? '' : 'margin-right-1'),
    "data-testid": "retail-game-view-container"
  }, React.createElement(DocumentTitle, {
    title: "".concat(name, " - ").concat(team.name, " - Spela tillsammans | Svenska Spel")
  }), React.createElement(ViewHeader, {
    boldDescription: containerDescription,
    description: description,
    game: game,
    gameTag: React.createElement(GameTypeTag, {
      productId: productId,
      subProductId: subProductId
    }),
    groupId: groupId,
    hasCloseButton: hasCloseButton,
    isFavorite: isFavorite,
    onGoBack: handleGoBack,
    onGoToTeam: handleGoToTeam,
    productId: productId,
    receiptFields: gameReceipt.getGameReceipt(game, team),
    richDescription: richDescription,
    subTitle: subTitles,
    teamName: team.name,
    title: name
  }), React.createElement("div", {
    className: "retail-game-view-body"
  }, React.createElement("div", {
    className: "f-center margin-2"
  }, isCurrentUserAuthenticated ? React.createElement(BoughtFractionsText, {
    currentPurchasedFractions: currentPurchasedFractions,
    isPastTime: isFinished,
    isSubmitted: isSubmitted,
    maxFractionsPerMember: maxFractionsPerMember
  }) : null, React.createElement(ActivatedDrawButtons, null)), renderBetProposalArea(), isSmall && !game.isSubmitted && React.createElement(FractionPayment, {
    activatedDrawId: game.activatedDrawId,
    className: fractionPaymentClasses,
    containerId: containerId,
    game: game,
    groupId: groupId,
    hasSnackbar: true,
    memberId: memberId
  })));
};
setGlobal('svs.marketplace.components.retailGameView.RetailGameView', RetailGameView);

 })(window);